import { BlueprintContext } from '../../blueprint-context/blueprint-context.class';
import { Components } from '../../../component-classes';
import { PanelItem } from '../panel-item.class';
import { PanelItemGroup } from '../../panel-item-groups/panel-item-group.class';
import { Vertex3 } from '../../../spatial-classes';

/**
 * applies delta to center to account for cutout
 *
 * @param panelItem instance of PanelItem
 * @param panelItemGroup instance of PanelItemGroup
 * @param center panelItem origin
 * @returns Point representing origin
 */
export const getCutoutCenterCfn = (panelItem: PanelItem, container: PanelItemGroup, context: BlueprintContext = null): Vertex3 => {
	const center = panelItem.center.clone();
	// no container, then retrurn center as absolute position
	if (container === null) {
		console.log('panelItem:getCenterCfn (no container)', center);
		return center;
	}

	const halfContainerHeight = (container.height ?? 0) / 2;
	// const halfContainerWidth = (container.width ?? 0) / 2;
	const halfContainerDepth = (container.depth ?? 0) / 2;

	const countertopThickness = panelItem.refMap?.island?.getCountertop()?.material.thickness ?? 0;

	// handle y binding
	if (panelItem.fullHeight) {
		// cutout spans full panel height, so center it in the container
		center.y = halfContainerHeight - (panelItem.cutout.height / 2);
	} else if (panelItem.item.placement === Components.PLACEMENT_FRONT_AND_TOP) {
		center.y = -halfContainerHeight + ((panelItem.item.distanceBelowCountertop - countertopThickness) / 2);

		if (panelItem.sleeve) {
			const component = context.components.findId(panelItem.sleeve);
			// Only apply the sleeve-depth offset for true sleeves (C1SLV / C3SLV).
			// Insulated jackets resolve as the sibling sleeve but have sleeveDepth=null,
			// so subtracting it would produce NaN and float the inner appliance cutout.
			if (component && component.sleeveDepth !== null) center.y += component.sleeveDepth - panelItem.item.distanceBelowCountertop;
		}
	} else if (panelItem.boundBottom && !panelItem.boundTop) {
		// shift cutout down so its bottom aligns with the item bottom
		center.y += (panelItem.size.height - panelItem.cutout.height) / 2;
	} else if (panelItem.boundTop && panelItem.item.distanceBelowCountertop !== null) {
		center.y = -(halfContainerHeight - (panelItem.cutout.height / 2) + countertopThickness);
		// center.y = -halfContainerHeight - countertopThickness + ((panelItem.item.distanceBelowCountertop ?? panelItem.cutout.height) / 2);
		// console.log('center.y', panelItem.item.sku, center.y, halfContainerHeight, panelItem.item.distanceBelowCountertop, countertopThickness);
	}

	if (panelItem.item.placement === Components.PLACEMENT_FRONT_AND_TOP) {
		const panelOverhang = panelItem.refMap?.panel?.countertopOverhang ?? 0;
		const distanceFrontOfFace = panelItem.item.distanceFrontOfFace ?? 0;
		const frontOfFace = Math.max(distanceFrontOfFace, panelOverhang);
		center.z = halfContainerDepth + frontOfFace - ((panelItem.cutout.depth + frontOfFace) / 2);
	}

	return center as Vertex3;
};
